module.exports = __webpack_public_path__ + "images/info-3302d20005d045934d1fd2694e8765b9.svg";